module.exports = __webpack_public_path__ + "img/poster.1cacb49c.png";